module.exports = __webpack_public_path__ + "media/images/gallery/figure_on-ec30a7c5962fb98193b8a3f27d2f74c4.gif";